module.exports = __webpack_public_path__ + "img/ISacredCow64_ua.4df2193b.webp";